/**
 * 这个工具主要的是处理字节，容量有关的方法
 */

export function formatBytes(bytes: number, decimals: number = 2) {
  if (bytes === 0) {
    return '0 Bytes';
  }
  var k = 1024,
    dm = decimals <= 0 ? 0 : decimals || 2,
    sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export function makePercentage(n1: number, n2: number) {
  return Math.floor((n1 / n2) * 100);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/bytesUtils.ts